import api from './api';

const notificationService = {
  getMy: async () => {
    const response = await api.get('/notifications/me', { validateStatus: () => true });
    return response.data;
  },

  markRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`, {}, { validateStatus: () => true });
    return response.data;
  },
};

export { notificationService };

